// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_V87vMh_","outer":"_1Y6KSCO","container":"_3afvuV_","tooltip":"_r7-LeRB"};